if (!customElements.get('amc-shipping-bar')) {
  class AmcShippingBar extends HTMLElement {
    connectedCallback() {
      this.threshold = parseInt(this.getAttribute('data-threshold'), 10) || 35000;
      this.fillEl = this.querySelector('[data-amc-fill]');
      this.truckEl = this.querySelector('[data-amc-truck]');
      this.textEl = this.querySelector('[data-amc-text]');
      this.confettiEl = this.querySelector('[data-amc-confetti]');

      var initialCents = parseInt(this.getAttribute('data-total-cents'), 10) || 0;
      this.wasComplete = this.classList.contains('is-complete');
      this.render(Math.round(initialCents / 100), false);

      var self = this;
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
          self.handleCartUpdate(event);
        });
      }
    }

    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
    }

    handleCartUpdate(event) {
      if (event && event.cartData && typeof event.cartData.total_price === 'number') {
        this.render(Math.round(event.cartData.total_price / 100), true);
        return;
      }
      var self = this;
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) { self.render(Math.round(cart.total_price / 100), true); })
        .catch(function () {});
    }

    render(total, animate) {
      var remaining = Math.max(0, this.threshold - total);
      var percent = Math.min(100, (total / this.threshold) * 100);
      var isComplete = remaining === 0;

      if (this.fillEl) this.fillEl.style.width = percent + '%';
      if (this.truckEl) this.truckEl.style.left = 'calc(' + percent + '% - 14px)';

      if (this.textEl) {
        this.textEl.innerHTML = isComplete
          ? '🎉 ¡Tienes envío gratis!'
          : 'Te faltan <strong>' + this.formatCLP(remaining) + '</strong> para envío gratis';
      }

      this.classList.toggle('is-complete', isComplete);

      if (isComplete && !this.wasComplete && animate) {
        this.burstConfetti();
      }
      this.wasComplete = isComplete;
    }

    formatCLP(n) {
      return '$' + Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }

    burstConfetti() {
      if (!this.confettiEl || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      var canvas = this.confettiEl;
      var ctx = canvas.getContext('2d');
      var rect = this.getBoundingClientRect();
      var dpr = window.devicePixelRatio || 1;
      canvas.width = rect.width * dpr;
      canvas.height = 90 * dpr;

      var colors = ['#E8792A', '#153229', '#F2C9C6', '#FBF6F0'];
      var particles = [];
      for (var i = 0; i < 36; i++) {
        particles.push({
          x: canvas.width / 2 + (Math.random() - 0.5) * 60 * dpr,
          y: canvas.height * 0.65,
          vx: (Math.random() - 0.5) * 7 * dpr,
          vy: (Math.random() * -7 - 2) * dpr,
          size: (Math.random() * 3 + 2) * dpr,
          color: colors[Math.floor(Math.random() * colors.length)],
          rotation: Math.random() * Math.PI,
          vr: (Math.random() - 0.5) * 0.35
        });
      }

      var start = null;
      var duration = 1100;

      function step(ts) {
        if (!start) start = ts;
        var elapsed = ts - start;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        particles.forEach(function (p) {
          p.vy += 0.2 * dpr;
          p.x += p.vx;
          p.y += p.vy;
          p.rotation += p.vr;
          ctx.save();
          ctx.translate(p.x, p.y);
          ctx.rotate(p.rotation);
          ctx.globalAlpha = Math.max(0, 1 - elapsed / duration);
          ctx.fillStyle = p.color;
          ctx.fillRect(-p.size / 2, -p.size / 2, p.size, p.size);
          ctx.restore();
        });
        if (elapsed < duration) {
          requestAnimationFrame(step);
        } else {
          ctx.clearRect(0, 0, canvas.width, canvas.height);
        }
      }
      requestAnimationFrame(step);
    }
  }

  customElements.define('amc-shipping-bar', AmcShippingBar);
}
